// extracted by mini-css-extract-plugin
export default {"quote":"quote_quote__N52+s","bottom":"quote_bottom__ALK+U"};